(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

/* eslint-disable no-param-reassign */
import * as T from "./types";

const getInitialState = () => ({
  // TODO: make subReducers
  searchString: "",
  countryCode: "",
  countries: {
    hasError: false,
    isLoading: false,
    data: []
  },
  history: {
    isLoading: false,
    hasError: false,
    data: []
  },
  hsCodes: {
    isLoading: false,
    hasError: false,
    data: null // {}

  },
  details: {
    data: {}
  },
  explanatoryNotes: {
    data: "",
    isLoading: false
  }
});

const _default = function () {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getInitialState();
  let action = arguments.length > 1 ? arguments[1] : undefined;
  const {
    payload
  } = action;

  switch (action.type) {
    case T.SET_SEARCH_STRING:
      state.searchString = payload;
      return state;

    case T.SET_COUNTRY_CODE:
      state.countryCode = payload;
      return state;

    case T.FETCH_COUNTRIES_PENDING:
      state.countries.isLoading = true;
      return state;

    case T.FETCH_COUNTRIES_FULFILLED:
      Object.assign(state.countries, {
        isLoading: false,
        hasError: false,
        data: payload
      });
      return state;

    case T.FETCH_COUNTRIES_REJECTED:
      Object.assign(state.countries, {
        isLoading: false,
        hasError: true
      });
      return state;

    case T.FETCH_HISTORY_PENDING:
      Object.assign(state.history, {
        isLoading: true,
        hasError: false
      });
      return state;

    case T.FETCH_HISTORY_FULFILLED:
      Object.assign(state.history, {
        data: payload,
        hasError: false,
        isLoading: false
      });
      return state;

    case T.FETCH_HISTORY_REJECTED:
      Object.assign(state.history, {
        hasError: true,
        isLoading: false
      });
      return state;

    case T.FETCH_HS_CODES_PENDING:
      Object.assign(state.hsCodes, {
        data: null,
        isLoading: true,
        hasError: false
      });
      return state;

    case T.FETCH_HS_CODES_FULFILLED:
      Object.assign(state.hsCodes, {
        isLoading: false,
        hasError: false,
        data: payload
      });
      return state;

    case T.FETCH_HS_CODES_REJECTED:
      Object.assign(state.hsCodes, {
        isLoading: false,
        hasError: true
      });
      return state;

    case T.FETCH_HS_CODE_DETAILS_FULFILLED:
      Object.assign(state.details, {
        data: { ...state.details.data,
          ["".concat(action.hsCode, "_").concat(action.countryCode)]: payload
        }
      });
      return state;

    case T.FETCH_HS_CODE_DETAILS_REJECTED:
      Object.assign(state.details, {
        data: { ...state.details.data,
          ["".concat(action.hsCode, "_").concat(action.countryCode)]: {
            hasError: true
          }
        }
      });
      return state;

    case T.CLEAR_HS_CODE_DETAILS:
      Object.assign(state.details, {
        data: {}
      });
      return state;

    case T.FETCH_EXPLANATORY_NOTES_FULFILLED:
      Object.assign(state.explanatoryNotes, {
        data: payload,
        isLoading: false,
        hasError: false
      });
      return state;

    case T.FETCH_EXPLANATORY_NOTES_PENDING:
      Object.assign(state.explanatoryNotes, { ...state.explanatoryNotes,
        isLoading: true,
        hasError: false
      });
      return state;

    case T.CLEAR_EXPLANATORY_NOTES:
      Object.assign(state.explanatoryNotes, {
        data: null,
        hasError: false
      });
      return state;

    case T.FETCH_EXPLANATORY_NOTES_REJECTED:
      Object.assign(state.explanatoryNotes, {
        data: null,
        isLoading: false,
        hasError: true
      });
      return state;

    default:
      return state;
  }
};

export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(getInitialState, "getInitialState", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/state/reducer.js");
  reactHotLoader.register(_default, "default", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/state/reducer.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();